__turbopack_context__.v({
  "bottomRight": "StopSticker-module-scss-module__T1PjGa__bottomRight",
  "stopSticker": "StopSticker-module-scss-module__T1PjGa__stopSticker",
});
